/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Section_6_IntroInputs */

const en_privacy_section_6_intro = /** @type {(inputs: Privacy_Section_6_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We retain your data for the following periods:`)
};

const lv_privacy_section_6_intro = /** @type {(inputs: Privacy_Section_6_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jūsu datus glabājam šādus laikposmus:`)
};

/**
* | output |
* | --- |
* | "We retain your data for the following periods:" |
*
* @param {Privacy_Section_6_IntroInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const privacy_section_6_intro = /** @type {((inputs?: Privacy_Section_6_IntroInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Section_6_IntroInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_privacy_section_6_intro(inputs)
	return en_privacy_section_6_intro(inputs)
});